export default {
  namespaced: true,
  state: {
    scrollHeight: 0, // 是否更新数据
  },
  mutations: {
    setScrollHeight(state, num) {
      state.scrollHeight = num;
    },
  },
  actions: {},
};
